<template>
    <a class="button-back" @click="back" v-show="replayBtn">
      <img src="media/global/btn_back.png"/>
      <div class="button-title">{{items.globalButtons.replayButton}}</div>
    </a>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    computed: {
      location () {
        return this.$store.state.scormLMS.location
      },
      items() {
        return this.$store.state.items
      },
      replayBtn() {
        return this.$store.state.replayBtn
      }
    },
    methods: {
      back() {
        this.$emit('replay');
      }
    },
    components: {},
    props: []
  }

</script>

<style scoped>
.button-back {
  position: absolute;
  bottom: 90px;
  left: 10px;
  z-index: 990;
  cursor: pointer;
  user-select: none;
  -webkit-filter: drop-shadow(1.5px 1.5px 1px #222 );
  filter: drop-shadow(1.5px 1.5px 1px #222);
}
.button-back.disabled {
  display: none;
  pointer-events: none;
  cursor: default;
}
.button-title {
  font-family: 'Nunito';
  position: absolute;
  bottom: 4px;
  left: 42px;
  z-index: 999;
  font-size: 13px;
  text-decoration: none;
  color: black;
}
@media only screen and (max-width: 750px) {
  .button-back {
    bottom: 5px;
  }
}

</style>



// WEBPACK FOOTER //
// ButtonReplay.vue?2bf79062